import React from "react";
import clsx from "clsx";

import { EmailUrls, LoginHelpText } from "globalConstants";

import { ReactComponent as FailureIcon } from "static/images/cancel.svg";
import { ReactComponent as CheckIcon } from "static/images/checked.svg";
import styles from "./confirmationBlock.module.scss";

export type ConfirmationBlockVariant = "success" | "failure";

type ConfirmationBlockProps = {
	title: string;
	variant: ConfirmationBlockVariant;
	hasContactInfo?: boolean;
	style?: React.CSSProperties;
};

const ConfirmationBlock = ({
	title,
	variant = "success",
	hasContactInfo = true,
	style,
}: ConfirmationBlockProps) => {
	const icon = (() => {
		switch (variant) {
			case "success":
				return <CheckIcon width="35" height="35" />;
			case "failure":
				return <FailureIcon width="35" height="35" />;
			default:
				return null;
		}
	})();

	return (
		<div className={clsx(styles.wrapper, styles[variant])} style={style}>
			<div className={styles.icon}>{icon}</div>
			<div className={styles.title}>{title}</div>
			{hasContactInfo && (
				<div className={styles.contactInfo}>
					<a href={`mailto:${EmailUrls.toHelp}`}>{LoginHelpText}</a>
				</div>
			)}
		</div>
	);
};

export default ConfirmationBlock;
